<template>
  <div class="py-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
      <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Support Tickets</h1>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-8">
      <div class="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-md">
        <div class="px-4 py-5 sm:px-6">
          <p class="text-gray-600 dark:text-gray-400">Support tickets management coming soon...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Support Tickets page placeholder
</script>
